import enUS from './locales/en-us.yaml'
import deDE from './locales/de-de.yaml'

export default {
  'en-us': enUS,
  'de-de': deDE
}
